import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { MenuService } from 'src/app/core/services/menu.service';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss']
})
export class VendorComponent implements OnInit {

  constructor(
    public helperService: HelperService,
    public menuService: MenuService,
    public storage: Storage) {
  }

  ngOnInit() { }

  ionViewWillEnter(){
    this.getStorage().then((res)=>{
      let obj = {};
      obj = {
        firstName: res.firstName,
        lastName: res.lastName,
        jobTitle: res.jobTitle,
        token: res.token,
        profileImageId: res.profileImageId
      }
      
      this.helperService.dataFromStorage(obj);
      this.menuService.storageToken(obj);
    })
  }

  async getStorage () {
    let data = {
      firstName: await this.storage.get("first_name"),
      lastName: await this.storage.get("last_name"),
      jobTitle: await this.storage.get("job_title"),
      token: await this.storage.get("token"),
      profileImageId: await this.storage.get("profile_image_id")
    }
    return data;
  }

}
